import React, { useState } from 'react';
import { X, Loader2, Clock } from 'lucide-react';

export default function MeeshoConnectModal({ isOpen, onClose, onConnect, sellerId }) {
  const [apiKey, setApiKey] = useState('');
  const [platformSellerId, setPlatformSellerId] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!apiKey.trim() || !platformSellerId.trim()) return;
    setSubmitting(true);
    try {
      await onConnect({
        sellerId,
        platform: 'MEESHO',
        refreshToken: apiKey.trim(),
        platformSellerId: platformSellerId.trim(),
      });
      setApiKey('');
      setPlatformSellerId('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b bg-gradient-to-r from-purple-50 to-pink-50/50">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-[#37475A] flex items-center justify-center">
              <span className="text-white font-bold text-sm">M</span>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-800">Connect Meesho</h3>
              <p className="text-xs text-gray-500">Link your Meesho Supplier account</p>
            </div>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
            <X size={18} className="text-gray-500" />
          </button>
        </div>

        {/* Coming Soon Banner */}
        <div className="mx-6 mt-5 flex items-center gap-3 p-3.5 bg-amber-50 border border-amber-200 rounded-lg">
          <Clock size={18} className="text-amber-600 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-amber-800">Coming Soon</p>
            <p className="text-xs text-amber-600 mt-0.5">
              Meesho integration is currently in development. You can save your credentials now and they will be activated when available.
            </p>
          </div>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              API Key <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder="Your Meesho API Key"
              required
              className="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#f08804]/20 focus:border-[#f08804]"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              Supplier ID <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={platformSellerId}
              onChange={(e) => setPlatformSellerId(e.target.value)}
              placeholder="Your Meesho Supplier ID"
              required
              className="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#f08804]/20 focus:border-[#f08804]"
            />
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting || !apiKey.trim() || !platformSellerId.trim()}
              className="inline-flex items-center px-5 py-2.5 text-sm font-medium text-white bg-[#37475A] hover:bg-[#232F3E] rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitting && <Loader2 size={16} className="mr-2 animate-spin" />}
              {submitting ? 'Connecting...' : 'Connect'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
